import { createPublicClient, http } from 'viem';
import { ChainId, PUBLIC_RPCS } from '../config/networks';
import { SupportedNetworks } from '../config/networkAddresses';
import { CURRENT_VERSION } from '../config/environment';
import { SolanaLoadBalancedClientManager } from '../../services/helpers/load-balancing/solana-load-balancer.service';
/**
 * Returns an RPC client for the specified chain ID.
 * @param {IGetRpcClient} options - The options for getting the RPC client.
 * @param {number} options.chainId - The chain ID for which to get the RPC client.
 * @returns {Client} The RPC client for the specified chain ID.
 * @throws {Error} If the chain ID is not supported.
 */
export function getEVMRpcClient({ chainId }) {
    if (chainId == ChainId.SOLANA) {
        throw new Error('Solana is non-EVM');
    }
    const networkConfig = SupportedNetworks(CURRENT_VERSION)[chainId];
    // @ts-ignore
    return createPublicClient({
        chain: networkConfig.chain,
        transport: http(PUBLIC_RPCS[chainId]),
    });
}
export async function getSolanaClient() {
    return SolanaLoadBalancedClientManager.getInstance().getConnection();
}
export function getClientManager() {
    return SolanaLoadBalancedClientManager.getInstance();
}
